import { Skeleton } from "@certn/cascadia-react/patterns/skeleton/Skeleton";
import { css } from "@emotion/css";

import { Text } from "../../foundations/typography/Text";
import { CopyToClipboard } from "../copy-to-clipboard/CopyToClipboard";
import { mq } from "../utils";

interface DataDisplayListProps {
  data: Record<string, any>[];
  title?: string;
  testID: string;
  isColumn?: boolean;
  className?: string;
  WithHeaderStyle?: boolean;
  showCopyButton?: boolean;
  isLoading?: boolean;
}

export function DataDisplayList(props: DataDisplayListProps) {
  const {
    data,
    title,
    isColumn,
    testID,
    WithHeaderStyle = false,
    showCopyButton = false,
    isLoading = false,
  } = props;
  return (
    <div className={css(styles.wrapper, props.className)} data-testid={testID}>
      {title && (
        <Text
          className={WithHeaderStyle ? styles.header : undefined}
          style="global/heading-medium"
        >
          {title}
        </Text>
      )}
      <div>
        {data?.map((item) => (
          <div
            data-testid={item?.label}
            key={item?.label}
            className={css(
              styles.row,
              mq({
                flexDirection: ["column", isColumn ? "column" : "row"],
                gap: ["none", isColumn ? "none" : "var(--space-4)"],
              })
            )}
          >
            <Text
              className={css(
                mq({
                  width: [undefined, isColumn ? undefined : "160px"],
                })
              )}
              style="global/heading-medium"
            >
              {item?.label}
            </Text>
            <div className={styles.valueContainer}>
              <Text
                className={styles.value}
                color="text-weak"
                style="global/body-primary"
              >
                {isLoading ? <Skeleton width={300} /> : item?.value}
              </Text>
              {showCopyButton &&
                item?.value &&
                typeof item?.value === "string" &&
                item?.value !== "--" && (
                  <CopyToClipboard
                    text={item?.value}
                    testID={`copy-${item?.label?.toLowerCase().replace(/\s+/g, "-")}`}
                    isHiddenUntilHover={false}
                    hideText={true}
                  />
                )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  header: css({
    borderRadius: "var(--border-radius-2)",
    padding: "var(--space-0) var(--space-3) var(--space-0) var(--space-3)",
    background: "var(--background-accent-neutral-weak)",
  }),
  wrapper: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
  row: css({
    display: "flex",
    paddingTop: "var(--space-1)",
    paddingBottom: "var(--space-2-5)",
  }),
  value: css({ display: "flex", flex: "1" }),
  valueContainer: css({
    display: "flex",
    alignItems: "center",
    gap: "var(--space-2)",
    flex: "1",
  }),
};
